const toLabelOption = value => ({
  id: value,
  value,
  name: value.replace(/_/g, ' ')
})

export const CONFIGURE_TYPES = [
  'STANDARD_MATERIAL_FORM',
  'SEQUENCE_TEMPLATE',
  'MATERIAL_FIXED_FIELDS'
].map(toLabelOption)
export const SOURCE_ITEMS = [
  'MATERIAL_FIXED_FIELDS', //   'STANDARD_FIELD',
  'PLUGIN_FIXED_FIELDS',
  'PLUGIN_CUSTOM_FIELDS',
  'STANDARD_MATERIAL_FORM'
].map(toLabelOption)

export const INPUT_TYPES = {
  TEXT: 1,
  LONG_TEXT: 2,
  NUMBER: 3,
  CUSTOM_LIST: 4,
  DATE: 7,
  TIME: 8,
  BOOLEAN: 12
}

export const MATERIAL_FIXED_FIELDS = [
  { name: 'Material Name', type: INPUT_TYPES.TEXT, id: 'material_name' },
  { name: 'Description', type: INPUT_TYPES.LONG_TEXT, id: 'material_description' },
  { name: 'Type', type: INPUT_TYPES.CUSTOM_LIST, id: 'material_type' },
  { name: 'Gross Weight', type: INPUT_TYPES.NUMBER, id: 'gross_weight' },
  { name: 'ERP Material ID', type: INPUT_TYPES.TEXT, id: 'erp_material_id' },
  { name: 'PLM Material Id', type: INPUT_TYPES.TEXT, id: 'plm_material_id' },
  { name: 'Material Group', type: INPUT_TYPES.CUSTOM_LIST, id: 'material_group' },
  { name: 'Unit of Material', type: INPUT_TYPES.CUSTOM_LIST, id: 'unit_of_material' },
  { name: 'Storage Location', type: INPUT_TYPES.CUSTOM_LIST, id: 'storage_loc' }
  // {name:, type:'text' ,id:}

]

export const MAP_ACTION_MATERIAL_FIXED_FIELDS = [
  ...MATERIAL_FIXED_FIELDS,
  { name: 'Dimension', type: INPUT_TYPES.TEXT, id: 'dimension' },
  { name: 'Volume', type: INPUT_TYPES.NUMBER, id: 'volume' }
]

export const PLUGIN_FIXED_FIELDS = [
  { name: 'Description', type: INPUT_TYPES.LONG_TEXT, id: 'description' },
  { name: 'PartNo', type: INPUT_TYPES.TEXT, id: 'PartNo' },
  { name: 'Number', type: INPUT_TYPES.TEXT, id: 'number' },
  { name: 'Revision', type: INPUT_TYPES.TEXT, id: 'revision' },
  { name: 'Material', type: INPUT_TYPES.TEXT, id: 'material' },
  { name: 'Finish', type: INPUT_TYPES.TEXT, id: 'finish' },
  { name: 'Weight', type: INPUT_TYPES.NUMBER, id: 'weight' },
  { name: 'stockSize', type: INPUT_TYPES.TEXT, id: 'stockSize' },
  { name: 'UnitOfMeasure', type: INPUT_TYPES.TEXT, id: 'unitOfMeasure' },
  { name: 'Cost - Material Cost', type: INPUT_TYPES.NUMBER, id: 'Cost - Material Cost' }
]

export const OPERATORS = [
  { name: 'Equals', id: 'EQUALS', applicableTo: [INPUT_TYPES.TEXT, INPUT_TYPES.LONG_TEXT, INPUT_TYPES.CUSTOM_LIST, INPUT_TYPES.DATE, INPUT_TYPES.BOOLEAN, INPUT_TYPES.NUMBER] },
  { name: 'Includes', id: 'INCLUDES', applicableTo: [INPUT_TYPES.TEXT, INPUT_TYPES.LONG_TEXT, INPUT_TYPES.LONG_TEXT, INPUT_TYPES.CUSTOM_LIST] }
  // { name: 'Does Not Equal', id: 'NOT_EQUALS', applicableTo: [INPUT_TYPES.TEXT, INPUT_TYPES.CUSTOM_LIST, INPUT_TYPES.DATE, INPUT_TYPES.BOOLEAN, INPUT_TYPES.NUMBER] },
  // { name: 'Contains', id: 'CONTAINS', applicableTo: [INPUT_TYPES.TEXT] },
  // { name: 'Greater Than', id: 'GREATER_THAN', applicableTo: [INPUT_TYPES.NUMBER] },
  // { name: 'Greater Than Or Equal', id: 'GREATER_THAN_OR_EQUAL', applicableTo: [INPUT_TYPES.NUMBER] },
  // { name: 'Less Than', id: 'LESS_THAN', applicableTo: [INPUT_TYPES.NUMBER] },
  // { name: 'Less Than Or Equal', id: 'LESS_THAN_OR_EQUAL', applicableTo: [INPUT_TYPES.NUMBER] },
  // { name: 'Is Any Of', id: 'IN', applicableTo: [INPUT_TYPES.CUSTOM_LIST] }
]
